<template>
  <div>
    <DialogArchives :sn="id" :show.sync="visible" width="1200px">
      <div class="component-archives-card">
        <div class="archives-card">
          <div class="archives-card-content">
            <div>
              <ComponentDialogArchivesTopCard
                :archive="archivesDetail.archive"
                :sn="sn"
              ></ComponentDialogArchivesTopCard>
            </div>
            <div class="mt-2">
              <div class="flex items-center">
                <dv-border-box-12
                  class="theme-padding"
                  :color="['#dcdfe6', '#dcdfe6']"
                  style="height: 530px"
                >
                  <div>
                    <el-descriptions class="pl-3 pr-3"> </el-descriptions>
                    <div class="pl-3 pr-3">
                      <template v-if="!fileList.length">
                        <el-empty description="暂无回访图片" />
                      </template>
                      <el-image
                        v-else
                        v-for="(item, index) in fileList"
                        :key="index"
                        :src="item.url"
                        style="width: 150px; height: 150px; margin-left: 10px"
                        :preview-src-list="fileList.map((v) => v.url)"
                        :alt="item.name"
                      ></el-image>
                    </div>
                  </div>
                </dv-border-box-12>
                <dv-border-box-12
                  class="theme-padding"
                  :color="['#dcdfe6', '#dcdfe6']"
                  style="height: 530px"
                >
                  <div class="archives-module-view pl-2 pr-2">
                    <ArchivesModuleView
                      :list="list"
                      :transferRawJson="transferRawJson"
                    ></ArchivesModuleView>
                  </div>
                </dv-border-box-12>
              </div>
            </div>
          </div>
        </div>
      </div>
    </DialogArchives>
  </div>
</template>
<script>
import { formatRiskLevel } from "../../utils/index";
import { mapGetters } from "vuex";
import * as echarts from "echarts";
import ComponentDialogArchivesTopCard from "../common/ArchivesTopCard.vue";
import DialogArchives from "../common/DialogArchives.vue";
import ArchivesModuleView from "./ArchivesModuleView.vue";
export default {
  components: {
    ComponentDialogArchivesTopCard,
    DialogArchives,
    ArchivesModuleView,
  },
  data() {
    return {
      archivesDetail: {
        archive: {},
        base: [],
        address: [],
        diseases: [],
      },
      patrolList: [],
      files: [],
      list: [],
      transferRawJson: {},
      fileList: [],
    };
  },
  props: {
    show: Boolean,
    sn: {
      type: String,
      default: "",
    },
    id: {
      type: [String, Number],
      default: "",
    },

    link: {
      type: String,
      default: "",
    },
    detail: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    sn: {
      handler(n) {
        if (!n) {
          return;
        }
        // this.getArchivesDetail();
      },
      deep: true,
    },
    id: {
      handler(n) {
        if (!n) {
          return;
        }
        // this.getPatrolDetail();
      },
      deep: true,
    },
    detail: {
      handler(n) {
        this.archivesDetail = n;
      },
      deep: true,
      immediate: true,
    },
    visible: {
      handler(n) {
        n && this.getPatrolDetail();
      },
    },
  },
  computed: {
    ...mapGetters(["globalData", "key", "token", "plotKey"]),
    visible: {
      get() {
        return this.show;
      },
      set(n) {
        return this.$emit("update:show", n);
      },
    },
  },

  methods: {
    getLevelBtn(level = 0) {
      let list = [
        {
          type: "success",
          name: formatRiskLevel(level),
        },
        {
          type: "success",
          name: formatRiskLevel(level),
        },
        {
          type: "warning",
          name: formatRiskLevel(level),
        },
        {
          type: "danger",
          name: formatRiskLevel(level),
        },
      ];
      console.log(list[level]);
      return list[level];
    },
    getPatrolDetail() {
      this.$axios
        .get(`/statisticsService/mechanism/visitDetail?id=${this.id}`)
        .then((resp) => {
          let response = resp.data;
          this.list = response.formData.fields;
          this.transferRawJson = response.data.answers;
          this.files = response.files;
          let fileList = response.files.map((v) => {
            return {
              name: v.filename,
              url: v.file_url,
            };
          });
          if (!this.transferRawJson.length) {
            return;
          }
          this.transferRawJson.map((v) => {
            if (
              v &&
              v.answer &&
              v.answer.linkAnswers &&
              v.answer.linkAnswers.value
            ) {
              fileList = [...fileList, ...v.answer.linkAnswers.value];
            }
          });
          console.log("fileList", fileList.flat(Infinity));
          this.fileList = fileList.flat(Infinity);
        });
    },
    async handleDetail() {
      if (!this.sn) return;
      let token = await this.$store.dispatch("app/getToken");
      let link = `${process.env.VUE_APP_ARCHIVES_DOMAIN}?accessToken=${token}&&key=${this.sn}`;
      window.open(link);
    },
  },
};
</script>
<style lang="less" scoped>
.component-archives-card {
  // backdrop-filter: blur(10px);
  background: #fff;
  height: 700px;
  border-radius: 10px;
  .archives-card {
    height: 100%;
    // width: 520px;
    width: 100%;
    .theme-padding {
      //   padding: 20px 0;
      padding: 20px 6px;
    }
    .archives-card-content {
      padding: 20px;
      .top-header {
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 80px;
        color: #4bace0;
        position: relative;
        .right-btn {
          border: 1px solid #4bace0;
          border-radius: 6px;
          padding: 4px 20px;
          position: absolute;
          right: 50px;
          top: 10px;
          cursor: pointer;
        }
        img {
          width: 74px;
          height: 74px;
          margin-right: 10px;
        }
        .name {
          font-size: 20px;
          font-weight: bold;
        }
        // background: linear-gradient(-90deg, #0e2f4e 0%, #0a1828 100%);
        background: linear-gradient(
          to left,
          #0d0c2f 0%,
          #103253 50%,
          #0d0c2f 100%
        );
      }
      .gender-img {
        width: 16px !important;
        height: 16px !important;
      }
    }
    .ill-btn {
      color: #f56c6c !important;
      /* background-color: #F56C6C; */
      border-color: #f56c6c !important;
      background: transparent;
    }
    .exporttable {
    }

    ::v-deep {
      .el-table::before {
        height: 0;
      }
      .el-table--border::after,
      .el-table--group::after {
        width: 0;
      }
      /**
改变边框颜色
 */
      .el-table--border,
      .el-table--group {
        border: 1px solid #4bace0 !important;
      }
      /**
改变表格内竖线颜色
 */
      .el-table--border td,
      .el-table--border th,
      .el-table__body-wrapper
        .el-table--border.is-scrolling-left
        ~ .el-table__fixed {
        border-right: 1px solid #4bace0 !important;
      }
      /**
改变表格内行线颜色
 */
      .el-table td,
      .el-table th.is-leaf {
        border-bottom: 1px solid #4bace0 !important;
      }

      .el-table thead tr th {
        border-color: #4bace0;
      }
      .el-table,
      .el-table__body {
        background: transparent !important;
        color: #abd1e7;
      }
      .el-table th {
        color: #abd1e7;
        background-color: transparent !important;
      }
      .el-table tr {
        background-color: transparent !important;
      }
      .el-table__body tr.hover-row > td {
        background-color: #a5ccf2 !important;
      }
      .el-table tbody tr:hover > td {
        background-color: #17468d !important; //修改成自己想要的颜色即可
      }
      .el-descriptions__body {
        color: #abd1e7;

        background: transparent !important;
      }
      .el-divider {
        background: #abd1e7;
      }
      .el-divider--horizontal {
        margin: 10px 0;
      }
      // .el-button {
      //   color: #f56c6c;
      //   /* background-color: #F56C6C; */
      //   border-color: #f56c6c;
      //   background: transparent;
      // }
    }
  }
  .archives-module-view {
    height: 100%;
    overflow: scroll;
  }
}
</style>
